// import { staffLoad } from "../../../../../backend/controllers/reportControllers/reportController";

function reducer(state, action) {
    switch(action.type) {
        case 'load': 
            console.log('Load Data');
            return loadData(state, action.payload); 
        case 'changeSemester':
            console.log('Change Semester')
            return {...state, ...{selectedSemester: action.payload.selectedSemester}}
        case 'changeTerm':
            console.log('Change Term')
            return {...state, ...{selectedTerm: action.payload.selectedTerm}}
        case 'changeTab':
            console.log('Change Tab')
            return {...state, ...{tab: action.payload.selectedTab}}
        case '1': 
            console.log('Section List');
            return showSection(state);
        case '2': 
            console.log('Group List');
            return showGroup(state);
        case 'loadStaff':
            return loadStaff(state,action.payload)
        case 'loadCourse':
            return loadCourse(state,action.payload)
        case 'staffLoads':
            return staffLoadLoader(state, action.payload)
        default: 
            console.log('Unknown action');
            return state;
    } 
}

const loadData = (state, dataset) => {
    const tableHeader = 'Batch List'
    const batchColumns = ['ID', 'Batch Year', 'Department', 'Semester ID', 
                                'Program Type', 'Admission Type', 'Year']
    const newState = {...state, ...{ 
        tableData: dataset.tableData,
        // .map(batch => {
        //     return [batch.id, batch.batch_year, batch.department, batch.semester_id, batch.program_type, batch.admission_type, batch.year]
        // }),
        tableColumn: batchColumns,
        tableHeader: tableHeader,
    }}
    return newState;
}
const showBatch = ( state, dataset ) => {
    console.log('hi')
    const newState = state;
    // const tableHeader = 'Batch List'
    // const batchColumns = ['ID', 'Batch Year', 'Department', 'Semester ID', 
    //                             'Program Type', 'Admission Type', 'Year']
    // const newState = {...state, ...{ 
    //     tableData: state.batchData.map(batch => {
    //         return [batch.id, batch.batch_year, batch.department, batch.semester_id, batch.program_type, batch.admission_type, batch.year]
    //     }),
    //     tableColumn: batchColumns,
    //     tableHeader: tableHeader      
    // }}
    return newState;
}
const showSection = ( state ) => {
    const tableHeader = 'Section List'
    const sectionColumns = ['ID', 'No. of students', 'Title', 'Batch Id']
    const newState = {...state, ...{ 
        tableData: state.sectionData.map(section => {
            return [section.id, section.no_students, section.title, section.batch_id]
           }),
        tableColumn: sectionColumns,
        tableHeader: tableHeader      

    }}
    return newState;
}
const showGroup = ( state ) => {
    const tableHeader = 'Group List'
    const groupColumns = ['ID', 'Type', 'Section Id']
    const newState = {...state, ...{ 
        tableData: state.groupData.map(group => {
            return [group.id, group.type, group.section_id]
           }),
        tableColumn: groupColumns,
        tableHeader: tableHeader      

    }}
    return newState;
}
const loadStaff = (state, dataset) => {
   const tableHeader ='Staff Progression Chart'
    // const tableColumn = ['Id', 'First Name', 'qualifications', 'department', 'position_id', 'rank_id', 'status_id']
    const tableColumn=[
        {
            name: "id",
            label: "ID",
            options: {
            filter: true,
            sort: true,
            }
        },
        {
            name: "fname",
            label: "First Name",
            options: {
            filter: true,
            sort: true,
            }
        },
        {
            name: "qual",
            label: "Qualification",
            options: {
            filter: true,
            sort: true,
            display:false
            }
        },
        {
            name: "dept",
            label: "Department",
            options: {
            filter: true,
            sort: true,
            }
        },
        {
            name: "pos",
            label: "Position ID",
            options: {
            filter: true,
            sort: true,
            }
        },

    ]
    const newState = {...state, ...{ 
        tableData: dataset.tableData,
        staffCount : dataset.staffCount,
        // .map(batch => {
        //     return [batch.id, batch.batch_year, batch.department, batch.semester_id, batch.program_type, batch.admission_type, batch.year]
        // }),
        tableColumn: tableColumn,
        tableHeader: tableHeader,
        partimer: dataset.partimer,
        fulltimer: dataset.fulltimer
    }}
    return newState;
}
const loadCourse = (state, dataset) => {
    const tableHeader = 'Course List'
    const tableColumn = ['Id', 'Course Name', 'Lecture', 'Lab hr', 'Tutorial hr', 'Cr hr', 'LEH']
    const newState = {...state, ...{
        tableData: dataset.tableData,
        tableColumn : tableColumn,
        tableHeader : tableHeader,
        totalCourse : dataset.totalCourse,
        activeCourse : dataset.activeCourse,
        regular : dataset.regular,
        extension : dataset.extension,
        undergraduate : dataset.undergraduate,
        postgraduate : dataset.postgraduate
    }}
    return newState;
}
const staffLoadLoader = (state,dataset) => {
    const newState = {...state, ...{
        staffLoad: dataset.staffLoad
    }}
    return newState;
}
export default reducer